/**
 * SSOT for Organized Tours HTTP paths (always blueprint-prefixed for Flask).
 * Dev Vite proxy must preserve `/api/lds/...` (see vite.config.js rewrite allowlist).
 */
export const ORGANIZED_TOUR_INFO_POST_PATH = "/api/lds/organized-tour/info";
export const ORGANIZED_TOUR_QUOTE_PDF_POST_PATH = "/api/lds/organized-tour/quote-pdf";
export const ORGANIZED_TOUR_RESOURCE_PROXY_PATH = "/api/lds/organized-tour/resource-proxy";
